const ServiceApi = {
    postCreate: '/crud/services',
    postAction: '/crud/services/:id/action',
    postOrder: '/crud/services/:id/order',

    putUpdate: '/crud/services/:id',

    deleteDestroy: '/crud/services/:id',

    getIndex: '/crud/services',
    getSelect: '/crud/services/select',
    getId: '/crud/services/:id',
}

export default ServiceApi;
